import api from '@/api';
import  * as dateutil from '@/util/date-helper.ts';

export default {  
    /**
     * 회의실 리스트를 가져옵니다.
     */
    getRooms(): Promise<any> {
        return api.post({
            url: '/api/ews/Resource/rooms?funcName=getRooms',
        }).then((res: any) => {
            return res;
        })
    },    
}